import React from 'react';

export const ViewContext = React.createContext({
	views: {
		clusterHierarchy: true,
		users: true,
		applications: true,
		logarithmicFeatures: true,
		ratioFeatures: true,
		scatterPlots: true
	},

	hiPlotModal: false,
	yAxisCoordinates: 'unified',
	hiPlotValues: [],
	setHiPlotValues: () => {},
	toggleViews: () => {},
	setHiPlotModal: () => {},
	setYAxisCoordinates: () => {}
});

export default ViewContext;
